/**
 * Vault D-21: after an admin creates, edits or deletes a user, tell the vault now instead of at
 * the nightly reconcile. Fire-and-forget — the server recomputes the user's state from Hub's own
 * database; a failure here only delays the cutoff until the reconcile.
 */
export type VaultLifecycleEvent = "created" | "updated" | "deleted";

export function syncVaultLifecycle(userId: string | null | undefined, event: VaultLifecycleEvent): void {
  if (!userId) return;
  void fetch("/api/vault/lifecycle/sync-user", {
    method: "POST",
    credentials: "same-origin",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ userId, event }),
  }).catch(() => undefined);
}
